import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  partnerInvoiceHistory,
  partnerInvoiceBill,
  invoiceHistory,
  partnerMyUnbilledInvoiceBill,
  partnerUnbilledInvoiceBillByTenant
} from "@/services/invoice";

@Module({
  namespaced: true
})
export default class Partner extends VuexModule {
  //state
  partnerInvoiceList = {};
  singleInvoiceData = {};
  partnerInvoiceBillDetails = {};
  myInvoiceHistoryPartner = {};
  partnerMyUnbilledInvoiceBills = {};
  partnerUnbilledInvoiceBillsByTenant = {};
  //action

  @Action
  public async fetchPartnerUnbilledInvoiceByTenant(payload) {
    try {
      const data = await partnerUnbilledInvoiceBillByTenant(payload);
      this.context.commit("setPartnerUnbilledInvoiceByTenant", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerMyUnbilledInvoice(payload) {
    try {
      const data = await partnerMyUnbilledInvoiceBill(payload);
      this.context.commit("setPartnerMyUnbilledInvoice", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchMyInvoiceHistoryPartner() {
    try {
      const data = await invoiceHistory();
      this.context.commit("setMyInvoiceHistoryPartner", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerInvoice(payload) {
    try {
      const data = await partnerInvoiceHistory(payload);
      this.context.commit("setPartnerInvoice", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async singlePartnerInvoice(data) {
    try {
      this.context.commit("setSinglePartnerInvoice", data);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async partnerInvoiceBill(payload) {
    try {
      const data = await partnerInvoiceBill(payload);
      this.context.commit("setPartnerInvoiceBill", data.response);
    } catch (error) {
      throw error;
    }
  }
  //mutation

  @Mutation
  public setPartnerUnbilledInvoiceByTenant(data: any) {
    this.partnerUnbilledInvoiceBillsByTenant = data;
  }

  @Mutation
  public setPartnerMyUnbilledInvoice(data: any) {
    this.partnerMyUnbilledInvoiceBills = data;
  }

  @Mutation
  public setMyInvoiceHistoryPartner(data: any) {
    this.myInvoiceHistoryPartner = data;
  }

  @Mutation
  public setPartnerInvoice(data: any) {
    this.partnerInvoiceList = data;
  }

  @Mutation
  public setPartnerInvoiceBill(data: any) {
    this.partnerInvoiceBillDetails = data;
  }

  @Mutation
  public setSinglePartnerInvoice(data: any) {
    this.singleInvoiceData = data;
  }

  //gatters

  get GetMyInvoiceHistoryPartner() {
    return this.myInvoiceHistoryPartner;
  }
  get GetPartnerInvoice() {
    return this.partnerInvoiceList;
  }

  get GetSingleInvoice() {
    return this.singleInvoiceData;
  }
  get GetInvoiceBill() {
    return this.partnerInvoiceBillDetails;
  }

  get GetPartnerMyUnbilledInvoice() {
    return this.partnerMyUnbilledInvoiceBills;
  }

  get GetPartnerUnbilledInvoiceByTenant() {
    return this.partnerUnbilledInvoiceBillsByTenant;
  }
}
